import { useMutation } from '@apollo/client/react';
import { SignOutDocument } from '@/graphql';
import { useAuth } from '../context';

/**
 * Hook for handling user sign-out
 * Calls backend to invalidate session, then clears local auth state
 */
export function useSignOut() {
  const { clearAuth } = useAuth();

  const [signOutMutation, { loading }] = useMutation(SignOutDocument, {
    onCompleted: async data => {
      if (data.signOut.success) {
        // Clear auth state and redirect to sign-in
        await clearAuth();
      }
    },
    onError: async () => {
      // Clear auth state anyway to prevent being stuck
      await clearAuth();
    }
  });

  const signOut = () => {
    signOutMutation();
  };

  return { signOut, loading };
}
